import { Box, IconButton, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import Icons from '../../../components/icons';
import { DeclarationItem, FileType } from '../types';

export const declarationFileColumns = (
  onFileLabelClick: (file: FileType) => void,
  onDelete: (declarationItem: DeclarationItem) => void
): GridColDef[] => {
  return [
    {
      field: 'name',
      headerName: 'File',
      flex: 1,
      renderCell: (params) => (
        <Box
          onClick={() => onFileLabelClick(params.row)}
          sx={{ cursor: 'pointer' }}
        >
          <Typography color='primary'>{params.row.name}</Typography>
        </Box>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label='remove'
          onClick={() => {
            onDelete(params.row);
          }}
        >
          <Icons.Delete />
        </IconButton>
      )
    }
  ];
};
